/**
 * Tiny bridge so the (non-React) axios interceptor can open the React upsell modal.
 * UpsellProvider registers its handler on mount; the interceptor calls triggerUpsell on a
 * subscription-limit error. Keeping this out of React means no circular imports between the
 * axios layer and the component tree.
 */
let handler = null;

export function setUpsellHandler(fn) {
  handler = fn;
}

export function triggerUpsell(payload) {
  if (typeof handler === "function") {
    handler(payload || {});
  }
}
